import { render, staticRenderFns } from "./disciplineCourses.vue?vue&type=template&id=3c3a2116&"
import script from "./disciplineCourses.vue?vue&type=script&lang=js&"
export * from "./disciplineCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports